// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d18797d3","977":"d3fc2cbf"}[chunkId] + ".chunk.js";
};